export default __webpack_public_path__ + "static/media/33.748a3610.jpg";